import React from 'react';

import MetricOptionsContext from '../../../contexts/MetricOptionsContext';
import useMetricOptions from '../../../hooks/useMetricOptions';

const MetricOptionsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const {
    metricOptions,
    metricOptionsLookup,
    metricOptionsNoSpecials,
    normalMetrics,
    datasetMetricOptions,
  } = useMetricOptions();

  return (
    <MetricOptionsContext.Provider
      value={{
        metricOptions,
        metricOptionsLookup,
        metricOptionsNoSpecials,
        normalMetrics,
        datasetMetricOptions,
        isLoading: false,
      }}
    >
      {children}
    </MetricOptionsContext.Provider>
  );
};

export default MetricOptionsProvider;
